import { render, staticRenderFns } from "./InspectionData.vue?vue&type=template&id=0b2339e0&scoped=true"
import script from "./InspectionData.vue?vue&type=script&lang=js"
export * from "./InspectionData.vue?vue&type=script&lang=js"
import style0 from "./InspectionData.vue?vue&type=style&index=0&id=0b2339e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2339e0",
  null
  
)

export default component.exports